export default __webpack_public_path__ + "static/media/services.1d5ca106.jpg";